export interface LedgerScope {
  period: string;
  bank?: string | undefined;
}

/** All collections keys live under ['collections'] so deal transitions can invalidate them at once. */
export const collectionKeys = {
  all: ['collections'] as const,
  summary: (s: LedgerScope) => [...collectionKeys.all, 'summary', s] as const,
  trend: (s: LedgerScope) => [...collectionKeys.all, 'trend', s] as const,
  receivables: (p: Record<string, unknown>) => [...collectionKeys.all, 'receivables', p] as const,
  invoices: (p: Record<string, unknown>) => [...collectionKeys.all, 'invoices', p] as const,
  invoice: (id: string) => [...collectionKeys.all, 'invoice', id] as const,
  candidates: (bank: string, period: string) => [...collectionKeys.all, 'candidates', bank, period] as const,
  payments: (p: Record<string, unknown>) => [...collectionKeys.all, 'payments', p] as const,
  payment: (id: string) => [...collectionKeys.all, 'payment', id] as const,
  runs: (bank?: string) => [...collectionKeys.all, 'runs', bank ?? 'all'] as const,
  run: (id: string) => [...collectionKeys.all, 'run', id] as const,
  periods: (bank?: string) => [...collectionKeys.all, 'periods', bank ?? 'all'] as const,
};
